import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Header } from '../../layout';

const ProductCapitolatoCategorySelector = () => {
    const navigate = useNavigate();

    // Handler for selecting Ninfa category
    const handleNinfaSelect = () => {
        // Navigate directly to Capitolato Form
        navigate('/capitolato/form');
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-red-50">
            <div className="absolute inset-0 bg-[radial-gradient(#1976d2_0.5px,transparent_0.5px)] [background-size:24px_24px] opacity-30" />

            <Header
                title="Categoria Capitolato"
                backText="Dashboard"
                backTo="/dashboard"
            />

            <div className="relative container mx-auto px-4 py-8 max-w-6xl">
                <div className="mb-8">
                    <h2 className="text-xl font-medium text-gray-700 mb-4 border-b border-gray-200 pb-2">
                        Seleziona una categoria per il capitolato
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 animate-fade-in">
                        <button
                            onClick={handleNinfaSelect}
                            className="bg-white border-2 border-gray-200 rounded-xl p-6 hover:border-red-500 hover:shadow-lg transition-all duration-300 flex items-center justify-center"
                        >
                            <img
                                src="/images/macrocagetorie/ninfa.png"
                                alt="Ninfa"
                                className="h-16 object-contain"
                            />
                        </button>
                    </div>
                </div>
            </div>

            <style>
                {`
                    @keyframes fadeIn {
                        from {
                            opacity: 0;
                            transform: translateY(10px);
                        }
                        to {
                            opacity: 1;
                            transform: translateY(0);
                        }
                    }

                    .animate-fade-in {
                        animation: fadeIn 0.5s ease-out forwards;
                    }
                `}
            </style>
        </div>
    );
};

export default ProductCapitolatoCategorySelector;
